import React from "react"
import { EditableText, EditableTextProps } from "@blueprintjs/core"

interface CustomEditableTextProps extends Omit<EditableTextProps, "onChange"> {
  path?: string
  onChange?: (path: string, value: string) => void
}
const CustomEditableText = ({
  value,
  path,
  onChange,
  disabled,
  ...otherProps
}: CustomEditableTextProps) => {
  const handleChange = (value: string) => onChange?.(path, value ? value : "")

  return (
    <EditableText
      disabled={disabled}
      value={value}
      onChange={handleChange}
      {...otherProps}
    />
  )
}

export default CustomEditableText
